import { gql } from '@apollo/client';

const UPDATE_USER = gql`
    mutation UpdateUser($input: UpdateUser!) {
        updateUser(input: $input) {
            data {
                email
                first_name
                id
                last_name
                phone_number
                status
                profile_image
                user_addresses {
                    address_type
                    city
                    country
                    id
                    state
                    street
                    user_id
                    zip_code
                }
            }
            message
            success
        }
    }
`;

const UPDATE_SETTINGS_MUTATION = gql`
    mutation UpdateSettings($input: UpdateSettings!) {
        updateSettings(input: $input) {
            data {
                allow_notifications
                createdAt
                id
                show_notifications
                theme
                user_id
            }
            message
            success
        }
    }
`;

const DELETE_NOTIFICATION = gql`
    mutation DeleteNotification($deleteNotificationId: Int!) {
        deleteNotification(id: $deleteNotificationId) {
            message
            success
        }
    }
`;

const LOGOUT_USER = gql`
    mutation Logout {
        logout {
            data {
                device_arn
                email
            }
            message
            success
        }
    }
`;

const FORGOT_PASSWORD = gql`
    mutation ResetPassword($input: ResetPasswordInput!) {
        resetPassword(input: $input) {
            message
            success
        }
    }
`;

export { UPDATE_USER, UPDATE_SETTINGS_MUTATION, DELETE_NOTIFICATION, LOGOUT_USER, FORGOT_PASSWORD };
